// extracted by mini-css-extract-plugin
module.exports = {"container":"pay_container__M1nCJ"};